import { strokeIconCss, BaseIconProps } from "@components/Icon";
import styled from "@emotion/styled";

import { ReactComponent as OrganizationIconSvg } from "src/assets/icons/organization.svg";

export default styled(OrganizationIconSvg)<BaseIconProps>`
  ${(props) => strokeIconCss(props)}
`;
